module.exports = __webpack_public_path__ + "img/dengweichaxun.d3c31931.jpg";